import script from "./stockV2Commons.vue?vue&type=script&lang=js"
export * from "./stockV2Commons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__